import { createContext, useContext } from 'react';

export const LevelUpContextInitialState = {
  // flag to check if manager is viewing the levelUp or reportee is.
  isLoggedInEmployeeManager: false,
  isRoleSelectionModalOpen: false,
  levelUpDetails: null,

  // for action items
  checkInInstanceId: null,
  checkInParentId: null,
  filterEmpIds: [],
  selectedOption: null,
  selectOptions: [],
};

export const LevelUpContext = createContext({});

export const useLevelUpContext = () => useContext(LevelUpContext);
